/** Where a mark on the attendance list comes from (OskLectureAttendanceSource). */
export enum LectureAttendanceSource {
  /** The student scanned the QR code from the station in the app. */
  App = 0,
  /** Somebody of the staff marked the student in the panel. */
  Panel = 1,
}

/** GET /MyOskLectureAttendanceLists - one lecture day of a group. */
export interface IMyOskLectureAttendanceListVm {
  guid: string;
  lectureGroupGuid: string;
  /** yyyy-MM-dd, Warsaw day. */
  lectureDay: string;
  topic?: string | null;
  presentCount: number;
  /** Current members of the group. */
  membersCount: number;
  /** The lectures of this day run on a station now - students can still confirm in the app. */
  isRunning: boolean;
  createdUtc: string;
}

/** GET/POST/PUT /MyOskLectureAttendanceList - a lecture day with every member of the group. */
export interface IMyOskLectureAttendanceListDetailsVm extends IMyOskLectureAttendanceListVm {
  lectureGroupName: string;
  /** The lectures run and the current user teaches - the screen can be shown on the station. */
  canShowOnStation: boolean;
  students: IMyOskLectureAttendanceStudentVm[];
}

export interface IMyOskLectureAttendanceStudentVm {
  studentGuid: string;
  displayName: string;
  email: string;
  /** False for a student who left the group after being marked on this list. */
  isMember: boolean;
  isPresent: boolean;
  /** Null when the student has not been marked. */
  source?: LectureAttendanceSource | null;
  markedUtc?: string | null;
  markedByName?: string | null;
}

/** POST /MyOskLectureAttendanceList - opens the list of a day (today without lectureDay); returns the existing one. */
export interface IMyOskLectureAttendanceListIm {
  lectureGroupGuid: string;
  /** yyyy-MM-dd; empty - today. */
  lectureDay?: string | null;
  topic?: string | null;
}

/** PUT /MyOskLectureAttendanceList - the topic and only the marks the user changed. */
export interface IMyOskLectureAttendanceListUm {
  guid: string;
  topic?: string | null;
  marks: IMyOskLectureAttendanceMarkIm[];
}

export interface IMyOskLectureAttendanceMarkIm {
  studentGuid: string;
  isPresent: boolean;
}

/** POST /MyOskLectureAttendanceScreen - shows or hides the attendance screen on the station. */
export interface IMyOskLectureAttendanceScreenIm {
  lectureGroupGuid: string;
  visible: boolean;
}

export interface IMyOskLectureAttendanceScreenVm {
  stationsCount: number;
}
